import React, { FC, HTMLAttributes, useEffect } from 'react'
import { hot } from 'react-hot-loader/root'
import { observer } from 'mobx-react'
import { RadioChangeEvent } from 'antd/es/radio'
import { Checkbox } from 'antd'
import { CheckboxChangeEvent } from 'antd/es/checkbox'
import { UserInfoHS } from 'src/commons/store/UserStore'
import { StyledUseBalance, StyledBalanceRadioGroup, StyledUseBalanceRadio } from 'src/pc/assets/styled/UseBalance'

type UseBalanceProps = {
  BalanceType: 0 | 1 | -1
  onChang: (type: 0 | 1 | -1) => void
} & HTMLAttributes<HTMLDivElement>

const UseBalance: FC<UseBalanceProps> = ({ BalanceType, onChang, ...other }) => {
  const UserInfo = UserInfoHS.SuccessResult
  const BalanceTypeChange = (e: RadioChangeEvent) => {
    onChang(e.target.value)
  }
  useEffect(() => {
    if (UserInfo) {
      if (!(UserInfo.balance > 0) && BalanceType === 0) {
        if (UserInfo.cash > 0) {
          onChang(1)
        } else {
          onChang(-1)
        }
      }
      if (!(UserInfo.cash > 0) && BalanceType === 1) {
        onChang(-1)
      }
    }
  }, [UserInfo])
  const UseBalanceChange = (e: CheckboxChangeEvent) => {
    if (e.target.checked) {
      if (UserInfo) {
        if (UserInfo?.balance > 0) {
          onChang(0)
        } else if (UserInfo?.cash > 0) {
          onChang(1)
        }
      }
    } else {
      onChang(-1)
    }
  }
  return (
    (UserInfo && (UserInfo.balance > 0 || UserInfo.cash > 0) && (
      <StyledUseBalance {...other}>
        <Checkbox checked={!(BalanceType === -1)} onChange={UseBalanceChange}>
          使用钱包支付<span>（使用此方式购买的商品不支持退款）</span>
        </Checkbox>
        <StyledBalanceRadioGroup layout="vertical" value={BalanceType} onChange={BalanceTypeChange}>
          {UserInfo.balance > 0 && (
            <StyledUseBalanceRadio value={0}>
              不可提现余额
              <span className="tips">
                （可用 <span className="balance">¥{UserInfo.balance}</span>）
              </span>
            </StyledUseBalanceRadio>
          )}
          {UserInfo.cash > 0 && (
            <StyledUseBalanceRadio value={1}>
              可提现余额
              <span className="tips">
                （可用 <span className="balance">¥{UserInfo.cash}</span>）
              </span>
            </StyledUseBalanceRadio>
          )}
        </StyledBalanceRadioGroup>
      </StyledUseBalance>
    )) ||
    null
  )
}

export default hot(observer(UseBalance))
